/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React, { useContext, useReducer } from 'react';

const SET_RESULT = 'SET_RESULT';
const SET_SUBMITTING = 'SET_SUBMITTING';
const SET_PAYMENT_FORM_SUBMIT = 'SET_PAYMENT_FORM_SUBMIT';

const FormObserverStateContext = React.createContext();
const FormObserverDispatchContext = React.createContext();

const FormObserverReducer = (state, action) => {
    switch (action.type) {
        case SET_RESULT: {
            const { valid, dirty } = action.payload;
            return {...state, isValid: valid, isDirty: dirty};
        }
        case SET_SUBMITTING: {
            return {...state, isSubmitting: action.payload};
        }
        case SET_PAYMENT_FORM_SUBMIT: {
            return {...state, paymentformSubmit: action.payload};
        }
        default: {
            throw new Error(`[FormObserverReducer] Unsupported action type: ${action.type}.`);
        }
    }
};

export const FormObserver = ({children}) => {
    const [state, dispatch] = useReducer(FormObserverReducer, {isDirty: false, isValid: false, isSubmitting: false, paymentformSubmit: null});
    return (
        <FormObserverStateContext.Provider value={state}> 
            <FormObserverDispatchContext.Provider value={dispatch}>
                {children}
            </FormObserverDispatchContext.Provider>
        </FormObserverStateContext.Provider>
    );

};


export const useFormObserverState = () => {
    const context = useContext(FormObserverStateContext);
    if (!context) {
        throw new Error('useFormObserverState must be used within a FormObserver');
    }
    return context;
};


/**
 * This following FormObserver hook is a special case--as the context objects are optional.  The dependent 
 * Form component is designed to handle itself when it has either a or no FormObserver parent. 
 */
export const useFormObserver = () => {
    const state = useContext(FormObserverStateContext);
    if (!state) {
        return {};
    }
    const dispatch = useContext(FormObserverDispatchContext);

    const notifyObserver = (valid, dirty = true) => {
        dispatch({type: SET_RESULT, payload: { valid, dirty }});
    };
    const setSubmitting = (submitting = true) => {
        dispatch({type: SET_SUBMITTING, payload: submitting});
    };
    const registerForm = (paymentformSubmit) => {
        dispatch({type: SET_PAYMENT_FORM_SUBMIT, payload: paymentformSubmit});
    };
    return {...state, notifyObserver, setSubmitting, registerForm};
};
